// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__suP2O","title":"Navbar_title__oAcBN"};